const gold = "#EFC475";

const white = "#F2F2F2";

const grey = "#4B515D";

const green = "#679894";

export { gold, white, grey, green };
